/**
 * User lifecycle + invitation status — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const USER_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING: "Pending",
  PENDING_INVITATION: "Pending Invitation",
  INVITED: "Invited",
  REVOKED: "Revoked",
  EXPIRED: "Expired",
  WITHDRAWN: "Withdrawn",
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];

const helpers = createStatusHelpers(USER_STATUS, USER_STATUS.ACTIVE);

export const USER_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeUserStatus = helpers.tryNormalize;
export const normalizeUserStatus = helpers.normalize;
export const isUserStatus = helpers.isStatus;
export const isAnyUserStatus = helpers.isAnyStatus;

/** Invitation / invite-flow statuses (not yet Active/Inactive accounts). */
export const INVITATION_STATUSES: readonly UserStatus[] = [
  USER_STATUS.PENDING_INVITATION,
  USER_STATUS.INVITED,
  USER_STATUS.PENDING,
  USER_STATUS.REVOKED,
  USER_STATUS.EXPIRED,
  USER_STATUS.WITHDRAWN,
];

export const isInvitationStatus = (status: string): boolean =>
  isAnyUserStatus(status, ...INVITATION_STATUSES);
